import { KidsHasKids } from '../../../../member-profile/components/KidsHasKids';

const KidsHasKidsPage = () => {
    return <KidsHasKids />;
};

export default KidsHasKidsPage;
